enum MediaQueries {
  NONE = '',
  XSMALL = '(max-width: 767px)',
  GXSMALL = '(min-width: 768px)',
  SMALL = '(min-width: 768px) and (max-width: 1023px)',
  GSMALL = '(min-width: 1024px)',
  MEDIUM = '(min-width: 1024px) and (max-width: 1279px)',
  // GMEDIUM = '(min-width: 1280px)',
  LARGE = '(min-width: 1280px)',
  // GLARGE = '',
  // XLARGE = '',
}

export default MediaQueries;
